import { z } from "zod";

export interface WordComponent {
  word: string;
  form: string;
  entryId?: string;
  formId?: string;
  targetSignature?: string;
  composition?: WordComposition;
}
export interface WordComposition {
  determiner: WordComponent;
  linkingElement: string;
  head: WordComponent;
}
export const MAX_WORD_COMPOSITION_DEPTH = 6;
export function compositionSpelling(composition: WordComposition): string {
  return composition.determiner.form + composition.linkingElement + composition.head.form;
}
export function emptyComposition(): WordComposition {
  return { determiner: { word: "", form: "" }, linkingElement: "", head: { word: "", form: "" } };
}
export function compositionHasSpelling(value:WordComposition):boolean {return [value.determiner,value.head].every(p=>!!p.form&&(!p.composition||compositionHasSpelling(p.composition)));}
function schema(depth: number, draft=false): z.ZodType<WordComposition> {
  const component = z.object({
    word: z.string().trim().min(draft?0:1).max(200),
    form: z.string().trim().min(draft?0:1).max(200),
    entryId: z.string().uuid().optional(),
    formId: z.string().uuid().optional(),
    targetSignature: z.string().max(200000).optional(),
    composition: depth < MAX_WORD_COMPOSITION_DEPTH ? schema(depth + 1,draft).optional() : z.never().optional(),
  }).strict().superRefine((part, ctx) => {
    if (part.composition && (!draft || (part.form&&compositionHasSpelling(part.composition))) && compositionSpelling(part.composition).normalize("NFC") !== part.form.normalize("NFC")) {
      ctx.addIssue({ code: "custom", path: ["composition"], message: "Die weitere Zerlegung muss die Schreibweise des Bestandteils ergeben." });
    }
  });
  return z.object({
    determiner: component,
    linkingElement: z.string().trim().max(20).regex(/^[a-zäöüß]*$/i, "Fugenzeichen bestehen aus Buchstaben."),
    head: component,
  }).strict();
}
export const wordCompositionSchema = schema(1);
export const wordDraftCompositionSchema = schema(1,true);
